import { CancelReasonsResponse } from "app/models/RequestFlow"
import { get } from 'app/utils/axios/kheti'

const fetchCancelReasons = async (params: {
  action: string
  entity: string
  requester: string
  random?: boolean
  lang?: string
}) => {
  try {
    return await get<CancelReasonsResponse[]>(
      '/hyperlocal/v1/reasons',
      params
    )
  } catch {
    return []
  }
}

export default fetchCancelReasons
